import { Injectable } from "@angular/core";
import { AuthConfig, OAuthService } from "angular-oauth2-oidc";

@Injectable({
  providedIn: "root",
})
export class AuthGoogleService {
  constructor(private oauthService: OAuthService) {
    this.inciarLoginGoogle();
  }

  inciarLoginGoogle() {
    console.log("Iniciando login google");
    const config: AuthConfig = {
      issuer: "https://accounts.google.com",
      strictDiscoveryDocumentValidation: false,
      clientId:"1073834998340-tqv90jm1nvcke9mi5ebdauh0rkiuf8fs.apps.googleusercontent.com",
      redirectUri: window.location.origin + "/auth/login",
      scope: "openid profile email",
    };
    this.oauthService.configure(config);
    this.oauthService.setupAutomaticSilentRefresh();
    this.oauthService.loadDiscoveryDocumentAndTryLogin();
  }

  loginGoogle() {
    return this.oauthService.initLoginFlow();
  }
  logoutGoogle() {
    this.oauthService.logOut();
  }
  getProfileGoogle() {
    return this.oauthService.getIdentityClaims();
  }
  getIdToken(): Promise<string> {
    return new Promise((resolve, reject) => {
      if (this.oauthService.hasValidIdToken()) {
        resolve(this.oauthService.getIdToken());
      } else {
        // Si no hay token válido, intentamos refrescar
        this.oauthService.loadDiscoveryDocumentAndTryLogin().then(() => {
          if (this.oauthService.hasValidIdToken()) {
            resolve(this.oauthService.getIdToken());
          } else {
            reject(new Error('No se pudo obtener un token válido'));
          }
        }).catch(error => {
          reject(error);
        });
      }
    });
  }
}
